import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import moment from 'moment';
import { AprobarCompromisos } from './modalAprobarCompromisos';

const TablaDesaprobarSolicitudDonacion = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    //{ id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [aprob, setAprob] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [tipocom, setTipocom] = useState(null);
  const [aprobaciones, setAprobaciones] = useState();
  const [aprodetalle, setAprodetalle] = useState();
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {

            if (x.idaprobaciones.includes(target.value)
              //|| x.compromisoaprob !== null ? x.compromisoaprob : '0'.includes(target.value)
              || moment.utc(x.fecha).format('DD-MM-YYYY').toLowerCase().includes(target.value.toLowerCase())
              || x.observaciones.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const seleccionarRegistrosd = () => {

    let devuelv = 0;

    let endpoint = `${op.conexion}/api/presupuesto/registrosdesaprobados?idefiscal=${idefiscal}&tipo=${7}&depart=${4}&devuelto=${"'" + devuelv + "'"}`;
    console.log(endpoint)
    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        setRecords(response.data);

      }
      setActivate(false)

    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })

  }

  const seleccionarSolicitudesApro = (id) => {

    let campos = "*"
    let nomtab = "aprobaciones";
    let nomid = "idaprobaciones";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idaprobaciones > 0) {
          setAprobaciones(response.data);
          seleccionarSolicitudesAproDetalles(id);
        } else {
          setAprobaciones();
          seleccionarSolicitudesAproDetalles(id);
        }

      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  };

  const seleccionarSolicitudesAproDetalles = (id) => {

    let campos = "*"
    let nomtab = "aprobacionesdetalle";
    let nomid = "idaprobaciones";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

    console.log(endpoint);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.length > 0) {
          setAprodetalle(response.data);
          setMostrar2(true);
        } else {
          setAprodetalle();
          setMostrar2(true);
        }

      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  };


  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionar = (op, data) => (e) => {

    if (op === 4) {
      setOperacion(4);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true)
    } else if (op === 2) {
      setOperacion(op);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    }

  }


  useEffect(() => {

    seleccionarRegistrosd();

  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  }

  const cerrar = () => {
    props.menu()
  }

  return (
    <section className='modal-azulGradiant mx-auto col-9'>

      <header className='header-azulGradiant'>
        <h3 >
          Desaprobación de Solicitudes de Donación

        </h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input col-3 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
        <button onClick={gestionar(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>

      </div>
      <div className="col-md-12 m-0" >
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{item.idaprobaciones}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '300px' }}>{item.observaciones}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{moment.utc(item.fecha).format('DD-MM-YYYY')}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '100px' }}>
                    <button onClick={gestionar(4, item)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i></button>
                    <button onClick={gestionar(2, item)} className="btn btn-sm mx-1 btn-success rounded-pill"><i className="fas fa-print"></i> Imprimir</button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <AprobarCompromisos
        show={mostrar2}
        operacion={operacion}
        aprobado={aprob}
        ubica={props.ubi}
        tipo={props.tipo}
        devolver={props.devueltov}
        tipocom={props.tipocom}
        aprobaciones={aprobaciones}
        aprodetalle={aprodetalle}
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistrosd}
      />


      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaDesaprobarSolicitudDonacion;